import React from 'react';
import { Field, useFormikContext } from 'formik';

import { FormErrorUI, FormLabelUI, AutoCompleteSelectUI } from '../Interface';

const ServiceSettingFields = ({ viewField, autoCompleteOptions }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  return (
    <div className="grid grid-cols-6 gap-x-4 mx-4 mb-5">
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="defServiceOperationQtyUnit"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Mennyiségi egység" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defServiceOperationQtyUnit} />}
          onChange={(_e, newVal) => {
            setFieldValue('defServiceOperationQtyUnit', newVal?.value ?? null).then(() => {
              validateField('defServiceOperationQtyUnit');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defServiceOperationQtyUnit !== '' }}
          selectedValue={values.defServiceOperationQtyUnit}
          dataset={autoCompleteOptions.serviceOperationQtyUnit}
        />
      </div>
    </div>
  );
};

export default ServiceSettingFields;
